import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { fetchContents } from '../store/contentSlice';
import ContentGrid from '../components/ContentGrid';

export default function Explore() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'all';
  const genre = searchParams.get('genre') || 'all';
  const query = (searchParams.get('q') || '').trim().toLowerCase();
  const dispatch = useDispatch();
  const { items, loading } = useSelector((state) => state.content);

  useEffect(() => {
    const params = { limit: 50 };
    if (type !== 'all') params.type = type;
    if (genre !== 'all') params.genre = genre;
    if (query) params.q = query;
    dispatch(fetchContents(params));
  }, [dispatch, type, genre, query]);

  let filtered = type === 'all' ? items : items.filter(i => i.type === type);
  if (genre !== 'all') filtered = filtered.filter(i => i.genre === genre);
  if (query) filtered = filtered.filter(i =>
    i.title.toLowerCase().includes(query) ||
    (i.creator_name && i.creator_name.toLowerCase().includes(query))
  );

  return (
    <div className="explore-page">
      <ContentGrid items={filtered} loading={loading} />
    </div>
  );
}
